var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpDownArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 51.28 92.85",
    style: {
      enableBackground: "new 0 0 51.28 92.85"
    },
    xmlSpace: "preserve",
    fill: "#CCCFD6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 17.09,
    width: 17.09,
    height: 17.09
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.09,
    width: 17.09,
    height: 17.09
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 34.19,
    y: 17.09,
    width: 17.09,
    height: 17.09
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 34.19,
    y: 58.66,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 85.4676 134.4173)",
    width: 17.09,
    height: 17.09
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 17.09,
    y: 75.76,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 51.2806 168.6043)",
    width: 17.09,
    height: 17.09
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 58.66,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 17.0935 134.4173)",
    width: 17.09,
    height: 17.09
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpDownArrows);
export default __webpack_public_path__ + "static/media/up-down-arrows.e7b22237440ef5a965b3277e9c15208a.svg";
export { ForwardRef as ReactComponent };